<template>
  <div class="time-small-slider" :class="timeSliderDetailed && ' slider-open'">
    <div v-if="enabled" class="time-slider">
      <div class="wrapper">
        <div class="play" :class="{playing}" @click="togglePlay">
          <div class="play-icon" />
        </div>
        <!-- <select-comp-wrapper
          v-model="internalDropdownValue"
          :options="timeOptions"
          :multiple="false"
          :can-bold="false"
          :can-chart="false"
        /> -->
        <div ref="root" class="root" @click="toggleTimeSlider" />
        <div 
          v-if="timeSliderDetailed" 
          id="detailed-time-wrapper"
          v-click-outside="handleClick"
          class="detailed-time-wrapper"
        >
          <TimeSlider v-model="pivotConfigP" :dimension-metas="dimensionMetas" :options="options" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { select as d3_select } from 'd3-selection'
import { scaleTime as d3_scaleTime } from 'd3-scale'
import TimeSlider from './TimeSlider.vue'
import ClickOutside from 'vue-click-outside'
import Size from '@/mixins/Size'
import device from '@/utils/device'
// import SelectCompWrapper from '@/components/table/SelectCompWrapper.vue'
export default {
  components: { TimeSlider },
  directives: { ClickOutside },
  mixins: [Size],
  model: {
    prop: 'pivotConfig',
    event: 'change',
  },
  props: ['pivotConfig', 'dimensionMetas', 'options'],
  data() {
    return {
      currentHover: null,
      playing: false,
      changeTimer: null,
      timeSliderDetailed: false,
    }
  },
  computed: {
    pivotConfigP: {
      get() {
        return this.pivotConfig
      },
      set(v) {
        this.$emit('change', v)
      },
    },
    internalPivotConfig: {
      get() {
        return JSON.parse(JSON.stringify(this.pivotConfig))
      },
      set(v) {
        this.$emit('change', v)
      },
    },
    // internalDropdownValue: {
    //   get() {
    //     return [this.internalValue]
    //   },
    //   set(selection) {
    //     this.internalValue = selection[0]
    //   },
    // },
    internalValue: {
      get() {
        return this.timeDim.values[0]
      },
      set(value) {
        clearTimeout(this.changeTimer)
        this.changeTimer = setTimeout(() => {
          this.timeDim.values = [value]
          this.timeTypeDim.values = [
            this.optToValue(
              this.dimensionMetas[this.timeDim.id].typeOptions.find(t => t.id === value.type)
            ),
          ]
          this.internalPivotConfig = { ...this.internalPivotConfig }
        }, 200)
      },
    },
    min() {
      return this.timeOptions[0].label
    },
    max() {
      return this.timeOptions[this.timeOptions.length - 1].label
    },
    timeDim() {
      return this.internalPivotConfig.dimensions.find(d => {
        return this.dimensionMetas[d.id]?.type === 'time'
      })
    },
    timeTypeDim() {
      return this.internalPivotConfig.dimensions.find(d => {
        return d.id === this.timeDim.id + '_type'
      })
    },
    enabled() {
      return (
        this.timeDim &&
        (this.timeDim.role === 'filters' || (this.pivotConfig.targetChart!=='heat-map' && this.timeDim.role === 'columns')) &&
        this.timeOptions.length > 1
      )
    },
    timeOptions() {
      let currentType = this.timeTypeDim.values[0].value
      return this.options[this.timeDim.id].filter(o => o.type && o.type === currentType)
    },
  },
  watch: {
    size() {
      this.draw()
    },
    timeOptions() {
      this.draw()
    },
    internalValue(v, prev) {
      // de poco sirve...
      if (v.value !== prev.value) {
        let allOptions = this.options[this.timeDim.id]
        let prevOpt = allOptions.find(to => to.id === prev.value)
        let newOpt = allOptions.find(to => to.id === v.value)
        if (prevOpt.timeValue !== newOpt.timeValue) {
          this.updateHandle(newOpt)
        }
      }
    },
  },
  mounted() {
    this.draw()
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleClick(e) {
      // para el v-click-outside
      let preventions = ['root', 'line', 'actual', 'small-pos-wrap']
      if (preventions.indexOf(e.target.className) === -1) this.closeTimeSlider()
    },
    handleScroll () {
      this.closeTimeSlider()
    },
    toggleTimeSlider() {
      this.timeSliderDetailed = !this.timeSliderDetailed
      if (this.timeSliderDetailed) {
        setTimeout(() => {
          //recalculando si se pinta mal
          let wrapper = document.getElementById('detailed-time-wrapper')
          var pos = wrapper.getBoundingClientRect()
          let el = (document.getElementsByClassName('map-container').length !== 0 ? document.getElementsByClassName('map-container')[0] : document.getElementsByClassName('left')[0]).getBoundingClientRect()
          if(pos.right > el.right) wrapper.style.left = el.right - pos.right  - (device === 'mobile' ? '' : 10) + 'px'
        }, 1)
      }
    },
    closeTimeSlider() {
      this.timeSliderDetailed = false
    },
    draw() {
      if (!this.$refs.root) return
      this.root = d3_select(this.$refs.root)

      // this.root.attr('width', w).attr('height', this.size.height)
      let line = this.root.selectAll('.line').data([null])
      line = line.merge(line.enter().append('div').attr('class', 'line'))
      line.style('transform', `translate(0,0)`)
      this.scale = d3_scaleTime()
      this.scale
        .domain([
          this.timeOptions[0].timeValue,
          this.timeOptions[this.timeOptions.length - 1].timeValue,
        ])
        .range([0, 100])

      let actualData = this.timeOptions.filter(
        (el, i) => i === 0 || i === this.timeOptions.length - 1
      )
      let actuals = this.root.selectAll('.actual').data(actualData, d => d.id)
      let actualsEnter = actuals.enter().append('div').attr('class', 'actual')
      actuals.exit().remove()
      actuals = actuals.merge(actualsEnter)
      actuals.style('left', d => `${this.scale(d.timeValue)}%`)
      actuals.style('top', '-5px')

      let handle = this.root.selectAll('.handle').data([null])
      let handleEnter = handle.enter().append('div').attr('class', 'handle')
      handleEnter.append('div').attr('class', 'small-pos-wrap')

      handle = handle.merge(handleEnter)
      handle.raise()

      this.updateHandle(this.timeOptions.find(to => to.id === this.internalValue.value))
    },
    updateHandle(bestOption, opts) {
      if (!this.scale || !bestOption) return
      let handle = this.root.selectAll('.handle')
      handle.select('.small-pos-wrap').text(bestOption.label)
      handle
        .transition()
        .duration(opts?.immediate ? 0 : 400)
        .style('left', `${this.scale(bestOption.timeValue)}%`)
    },
    optToValue: o => {
      return {
        value: o.id,
        type: o.type,
      }
    },
    getClosest(date) {
      let bestOption = this.timeOptions.reduce(
        (best, o) => {
          let dist = Math.abs(o.timeValue.getTime() - date.getTime())
          if (best.dist > dist) {
            best = { ...o, dist }
          }
          return best
        },
        { dist: Infinity }
      )
      this.currentHover = bestOption
      return bestOption
    },
    togglePlay() {
      if (this.playing) this.pause()
      else this.play()
    },
    play() {
      this.closeTimeSlider()
      this.playing = true
      let currIdx = this.timeOptions.findIndex(o => o.id === this.internalValue.value)
      if (currIdx === this.timeOptions.length - 1) {
        this.internalValue = this.optToValue(this.timeOptions[0])
        this.playLoop()
      } else {
        this.playLoop({ immediate: true })
      }
    },
    pause() {
      this.closeTimeSlider()
      this.playing = false
      clearTimeout(this.changeTimer)
      clearTimeout(this.playTimer)
    },
    playLoop(opts) {
      clearTimeout(this.playTimer)
      this.playTimer = setTimeout(
        () => {
          let nextIdx = this.timeOptions.findIndex(o => o.id === this.internalValue.value) + 1
          if (nextIdx < this.timeOptions.length) {
            this.internalValue = this.optToValue(this.timeOptions[nextIdx])
            this.playLoop()
          } else this.pause()
        },
        opts?.immediate ? 0 : 1600
      )
    },
  },
}
</script>

<style lang="stylus" scoped>

.slider-open
  border-bottom: 1px solid $corporate_color_light !important

  &:after
    m-triangle("down", $corporate_color_light, 14)
    bottom: vw(-14px)
    left: 50%
    transform: translateX(-50%)

.time-small-slider
  position: relative
  z-index: 2
  width: vw(250px)
  border-bottom: 1px solid transparent

  .time-slider
    // min-height: 100px
    margin: vw(25px) 0 vw(10px)

    // .dots
    // display: flex
    // align-items: center
    // overflow-y: auto
    // margin-bottom: vw(30px)
    // max-width: 85vw
    // gap: vw(10px)

    // .dot
    // m-font-size(16, 26)
    // width: vw(40px)
    // cursor: pointer

    // &:hover,
    // &.current
    // font-weight: bold

    // &.current
    // cursor: default
    .wrapper
      display: flex
      align-items: center

      .detailed-time-wrapper
        $top-height = vw(85px)
        position: absolute
        padding: vw(50px) vw(20px) vw(10px)
        border: 1px solid $corporate_color_light
        background-color: white
        top: 0
        transform: translate(0, $top-height)
        width: 70vw

        .mobile &
          width: 100vw
      .play
        display: flex
        justify-content: center
        align-items: center
        margin-right: vw(15px)
        width: vw(32px)
        height: vw(32px)
        border-radius: 50%
        background-color: #000
        cursor: pointer

        .play-icon
          m-icon("play", 20, #fff)
          margin-left: 1px

        &.playing
          .play-icon
            m-icon("pause", 20, #fff)

      .custom-dropdown
        display: none
        flex: 0 0 vw(100px)

      .min,
      .max
        m-font-size(16, 26)
        color: #000
        font-weight: 600

      >>> .root
        flex: 1 1 0%
        margin-right: vw(20px)
        margin-left: vw(20px)
        width: 100%
        height: vw(30px)
        transform: translate(0, 50%)

        .line
          margin-top: vw(-1px)
          width: 100%
          height: 1px
          background-color: $grey

        .tick
          position: absolute

          .text
            position: absolute
            top: 0
            color: $grey
            transform: translate(-50%, -150%)

          .line
            position: absolute
            top: 0
            width: 1px
            height: vw(20px)
            border-left: solid 1px $grey

        .actual
          position: absolute
          width: 1px
          height: 10px
          background: $grey

        .handle
          $circle-height = vw(30px)
          $top = "calc(-100% - %s)" % $circle-height
          position: absolute

          // transition: transform 0.3s ease-in-out
          .small-pos-wrap
            position: absolute
            width: max-content
            height: $circle-height
            border-radius: 3px
            background-color: $lighter-blue
            transform: translate(-50%, -50%)
            m-font-size(14, 16)
            display: flex
            align-items: center
            padding: 0 vw(5px)

          .tooltip
            m-font-size(14, 20)
            position: absolute
            padding: vw(4px) vw(8px)
            border-radius: 4px
            background-color: $grey-dark
            color: #fff
            transform: translate(-50%, $top)

            &:after
              m-triangle("down", $grey-dark, 6)
              bottom: vw(-5px)
              left: 50%
              transform: translateX(-50%)
</style>
